<template>
    <div class="main-container px-5 py-5 xl:px-10">
        <AdminIndex v-if="isAdmin" />
        <UserIndex v-else />
    </div>
</template>


<script setup>  
import {  computed } from 'vue';
import { useStore } from 'vuex';
import UserIndex from './User/UserIndex.vue';
import AdminIndex from './Admin/AdminIndex.vue';

const store = useStore();
const isAdmin = computed(() => {
    return store.getters.isAdmin;
});
</script>

<style scoped>
</style>